/**
 * OS AVISOS DO FORMULÁRIO EM PORTUGUÊS — T26.R14 (relatório de uso de 09/10/2026).
 *
 * O testador: «mensagem de validação do cadastro em inglês». O aviso de campo vazio é o balão do
 * próprio navegador, e ele fala a língua do navegador — "Please fill out this field" para quem tem
 * o Chrome em inglês, mesmo num site em português. `setCustomValidity` troca o texto do balão; o
 * formulário inteiro passa por aqui com dois ouvintes na captura, e nenhum campo precisa saber.
 */
import type { FormEvent } from "react";

type Campo = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;

/** A frase para cada motivo de recusa do navegador; `null` quando o campo está válido. */
export function avisoEmPortugues(v: ValidityState, tipo?: string): string | null {
  if (v.valid) return null;
  if (v.valueMissing) return tipo === "checkbox" ? "Marque esta caixa para continuar." : tipo === "radio" ? "Escolha uma das opções." : "Preencha este campo.";
  if (v.typeMismatch) return tipo === "email" ? "Escreva um e-mail válido, como nome@exemplo.com." : "Este valor não está no formato certo.";
  if (v.tooShort) return "Este campo está curto demais.";
  if (v.tooLong) return "Este campo está longo demais.";
  if (v.patternMismatch) return "Este valor não está no formato pedido.";
  if (v.rangeUnderflow || v.rangeOverflow) return "Este valor está fora do permitido.";
  return "Confira este campo.";
}

/** Para `onInvalidCapture` do `<form>`: põe a frase em português no balão. */
export function aoFicarInvalido(e: FormEvent<HTMLFormElement>) {
  const campo = e.target as Campo;
  if (!campo || typeof campo.setCustomValidity !== "function") return;
  campo.setCustomValidity("");
  const frase = avisoEmPortugues(campo.validity, (campo as HTMLInputElement).type);
  if (frase) campo.setCustomValidity(frase);
}

/** Para `onInputCapture`/`onChangeCapture`: a frase sai assim que a pessoa mexe no campo. */
export function aoMexer(e: FormEvent<HTMLFormElement>) {
  const campo = e.target as Campo;
  if (campo && typeof campo.setCustomValidity === "function") campo.setCustomValidity("");
}
